<template>
  <div>
    <div class="card" style="width:645px">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Booking Travel for {{ pnrData.traveler.profile.firstName }}
            {{ pnrData.traveler.profile.lastName }}...
          </p>
          <b-button
            type="button"
            icon="close-circle"
            @click="$emit('close', pnrResult)"
            :disabled="pnrResult.jobStatus != 'done'"
          >
            Close</b-button
          >
        </header>
        <section class="modal-card-body">
          <template>
            <section class="my-4 ">
              <div class="has-text-grey is-size-7 has-text-right is-uppercase">
                Booking Id #{{ pnrData.bookingKey }}
              </div>

              <div class="mb-4">Status: {{ pnrResult.jobStatus | capitalize }}</div>
              <div v-if="pnrResult && pnrResult.jobStatus != 'done'">
                <div v-for="stage in pnrResult.stages" :key="stage.slug">
                  <!-- <b-loading :is-full-page="false" v-model="action.isComplete" :can-cancel="false" > -->
                  <div class="card-content p-3">
                    <div class="media">
                      <div class="media-left">
                        <ClipLoader
                          :loading="!stage.isComplete"
                          color="grey"
                          size="25px"
                        />
                        <b-icon
                          v-if="stage.isComplete"
                          icon="check"
                          type="is-success"
                          size="is-medium"
                        >
                        </b-icon>
                      </div>
                      <div class="media-content is-size-6">
                        <p>{{ stage.name }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- </b-loading> -->
                </div>
              </div>
              <div v-if="pnrResult.jobStatus == 'done' && pnrResult.success !== true">
                <div class="my-4">
                  <h3 class="is-size-4 mb-2">Booking Failed</h3>
                  <p class="mb-5 notification is-light is-danger">
                    We encountered an error with your booking and it has not
                    been completed. Please try to submit your booking again or
                    contact us using one of the methods below to complete your
                    booking.
                  </p>

                  <AmadeusBookingErrors :bookingKey="bookingKey" />
                  <p class="mb-2">
                    Email Gant's Online Team:
                    <a href="mailto:clientservices@ganttravel.com">
                      clientservices@ganttravel.com
                    </a>
                  </p>
                  <p class="mb-2">
                    Contact Gant Travel directly for agent assistance at
                    877-924-0303
                  </p>

                </div>
              </div>
            </section>
          </template>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import bookingMixin from "../../mixins/bookingMixin";
import AmadeusBookingErrors from "@/components/BookTravel/AmadeusBookingErrors.vue";

export default {
  name: "PNRPending",
  mixins: [bookingMixin],
  components: {
    ClipLoader,
    AmadeusBookingErrors,
  },
  props: {
    pnrData: Object,
  },
  data: function() {
    return {
      intervalID: null,
      intervalOFF: null,
      pnrResult: {
        bookingKey: this.bookingKey,
        jobStatus: "Loading...",
        success: false,
        stages: [],
      },
    };
  },
  computed: {
    isMeetingMode() {
      if (this.$store.state.meetings.meetingInfo) {
        return true;
      }
      return false;
    },
    bookingKey() {
      return this.pnrData.bookingKey;
    },
    statusInterval() {
      return this.$appConfig.updatingTimePNR || 3000;
    },
    timeLimit() {
      return this.$appConfig.timeLimitPNR || 120000;
    },
  },
  methods: {
    checkStatus() {
      //if (this.bookTrip.currentlyBooking || this.$route.path == '/summary' || this.$route.path == '/meetings/summary') {
      console.log("status check");
      var self = this;
      var body = { bookingKey: this.bookingKey };
      this.$app
        .huddleLabsServerCall("amadeus/pnr/multi-checkout/status", body)
        .then((result) => {
          this.pnrResult = result;

          if (result.jobStatus == 'done') {
            console.log("booking completed");
            clearInterval(self.intervalID);
            this.$emit("complete", result);
          } else {
            console.log("booking still pending");
          }
        });
      //}
    },
    //Stop waiting for the booking to complete and send failed result
    cancel() {
      clearInterval(this.intervalID);
      console.log("booking timed out");

      var context = this;
      setTimeout(() => {
        context.pnrResult.jobStatus = 'done';
        context.pnrResult.success = false;
      }, this.statusInterval);

      /*
      let result = {
        bookingKey: this.bookingKey,
        jobStatus: 'done',
        success: false,
        stages: [],
      };

      this.$emit("complete", result);
      */
    },
  },
  mounted() {
    this.intervalID = setInterval(this.checkStatus, this.statusInterval);
    this.intervalOFF = setTimeout(this.cancel, this.timeLimit);
  },
  beforeDestroy() {
    clearInterval(this.intervalID);
  },
};
</script>

<style scoped>
.column_wrapper {
  max-height: 200px;
  display: flex;
  flex-flow: column wrap;
}
</style>
